import advanceRegexInfo from 'styles/assets/png/advanceRegex.png';

import classes from 'components/common/GlobalFiltersInPage/components/searchByNameFilter/components/AdvancedWrapperTooltipContent/AdvancedWrapperTooltipContent.module.scss';

export const AdvancedWrapperTooltipContent = () => {
    return (
        <div className={classes.advancedWrapperTooltipContentContainer}>
            <div className={classes.title}>Advanced name search uses standard regular expression (Regex) syntax </div>
            <img src={advanceRegexInfo} alt={'Advanced Info'} className={classes.image} />
        </div>
    );
};
